<template>
  <v-container tag="section" class="content detail">
    <v-row>
      <v-col cols="12">
        <template v-if="$auth.user().people == null">
          <v-alert type="info">
            {{ $t("my_family.warning_alert_no_people") }}
          </v-alert>
        </template>
        <v-card class="mx-auto mt-0" color="white" max-width="100%" v-else>
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <template v-else>
            <v-img
              class="white align-end"
              height="300px"
              :src="'/img/background.jpg'"
            >
            </v-img>
            <v-card-title>
              <h2 class="mb-3 mt-3">
                <v-avatar class="mr-2" :color="currentColor()">
                  <v-icon dark large>
                    mdi-account-circle
                  </v-icon>
                </v-avatar>
                {{ $t("my_family.title") }}
              </h2>
            </v-card-title>

            <v-card-text class="mt-3">
              <v-row class="mt-5 mb-5">
                <v-col class="text-right">
                  <v-btn :color="currentColor()" href="/">{{
                    $t("all_course_types")
                  }}</v-btn>
                </v-col>
              </v-row>
              <template v-if="$auth.user().people">
                <hr class="mb-4">
                <v-row>
                  <v-col>
                    <h3 class="mb-5">{{ $t("my_family.parent_data") }}</h3>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      small
                      text
                      @click="addEditParent($auth.user().people)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                      {{ $t("edit_verb") }} </v-btn
                    >
                  </v-col>
                </v-row>
                <v-simple-table class="my-4 ml-2 table-striped">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th class="text-left" style="width: 20%">
                          {{ $t("register.name") }}
                        </th>
                        <td>{{ $auth.user().people.display_name }}</td>
                      </tr>
                      <tr>
                        <th class="text-left">
                          {{ $t("register.email") }}
                        </th>
                        <td>{{ $auth.user().people.email }}</td>
                      </tr>
                      <tr>
                        <th class="text-left">
                          {{ $t("register.tax") }}
                        </th>
                        <td>{{ $auth.user().people.tax }}</td>
                      </tr>
                      <tr v-if="$auth.user().people.billing_first_name || $auth.user().people.billing_last_name">
                        <th class="text-left">
                          {{ $t("billing_name") }}
                        </th>
                        <td>{{ $auth.user().people.billing_first_name }} {{ $auth.user().people.billing_last_name }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              <hr>
              <v-divider></v-divider>

              <v-card color="grey lighten-2">
                <v-card-text>
                  <h3 class="mb-5 mt-5">
                    <v-avatar color="indigo" size="30" class="mr-1 mb-1">
                      <span class="white--text text-">{{
                        children ? children.length : 0
                      }}</span>
                    </v-avatar>
                    {{ $t("Children") }}
                  </h3>
                  <template>
                    <v-simple-table class="my-5 ml-3" light>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("Name") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Geburtstag") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Steuernummer") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Telefonnummer") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="children && children.length">
                          <tr
                            v-for="(child, childIndex) in children"
                            :key="childIndex"
                          >
                            <td>
                              {{ child.first_name }} {{ child.last_name }}
                            </td>
                            <td>
                              {{ child.birth | formatDate }}
                            </td>
                            <td>
                              {{ child.tax }}
                            </td>
                            <td>
                              {{ child.phone }}
                            </td>
                            <td>
                              <v-btn
                                small
                                text
                                color="indigo"
                                @click="addEditChildren(child)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                                {{ $t("edit_verb") }} </v-btn
                              ><br />
                              <v-btn
                                small
                                v-if="1 == 2"
                                text
                                color="red"
                                @click="deleteChildren(child)"
                              >
                                <v-icon>mdi-delete</v-icon>
                                {{ $t("delete_verb") }}
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <td colspan="4">{{ $t("Keine Daten vorhanden") }}</td>
                        </tbody>
                      </template>
                    </v-simple-table>

                    <v-dialog v-model="registrationEditDialog" width="800">
                      <v-card>
                        <v-card-title
                          :color="currentColor()"
                          class="text-h5 grey lighten-2 pb-3"
                          v-if="registrationEditFormValues.people"
                        >
                          {{ registrationEditFormValues.people.first_name }}
                          {{ registrationEditFormValues.people.last_name
                          }}<br />
                          {{ registrationEditFormValues.courseWeek.name }}
                        </v-card-title>
                        <v-card-text>
                          <v-form ref="form" lazy-validation>
                            <v-row>
                              <v-col>
                                <v-select
                                  filled
                                  v-model="registrationEditFormValues.day_type"
                                  :items="
                                    (() => {
                                      let tmp = [];
                                      if (
                                        registrationEditFormValues.courseWeek &&
                                        registrationEditFormValues.courseWeek
                                          .full_day
                                      ) {
                                        tmp.push({
                                          key: 'full_day',
                                          label:
                                            $i18n.locale == 'de'
                                              ? registrationEditFormValues
                                                  .course.label_full_day_de
                                              : registrationEditFormValues
                                                  .course.label_full_day_it
                                        });
                                      }
                                      if (
                                        registrationEditFormValues.courseWeek &&
                                        registrationEditFormValues.courseWeek
                                          .half_day
                                      ) {
                                        tmp.push({
                                          key: 'half_day',
                                          label:
                                            $i18n.locale == 'de'
                                              ? registrationEditFormValues
                                                  .course.label_half_day_de
                                              : registrationEditFormValues
                                                  .course.label_half_day_it
                                        });
                                      }
                                      return tmp;
                                    })()
                                  "
                                  :label="$t('course_registration.day_type')"
                                  hide-details
                                  item-text="label"
                                  item-value="key"
                                ></v-select>
                              </v-col>
                            </v-row>

                            <v-divider></v-divider>

                            <h3 class="heading mt-5 mb-2">
                              {{ $t("emergency_contacts") }}
                            </h3>
                            <v-row>
                              <v-col cols="12" class="pb-0">
                                <v-text-field
                                  color="secondary"
                                  :label="`${$t('emergency_contact')} 1*`"
                                  name="emergency_contact1_phone"
                                  v-validate="'required'"
                                  required
                                  prepend-icon="mdi-phone-alert"
                                  v-model="
                                    registrationEditFormValues.emergency_contact1_phone
                                  "
                                  :data-vv-name="`${$t('emergency_contact')} 1`"
                                  :error-messages="
                                    errors.collect('emergency_contact1_phone')
                                  "
                                />
                              </v-col>
                              <v-col cols="12" class="pt-0">
                                <v-text-field
                                  color="secondary"
                                  :label="`${$t('emergency_contact')} 2`"
                                  name="emergency_contact2_phone"
                                  prepend-icon="mdi-phone-alert"
                                  v-model="
                                    registrationEditFormValues.emergency_contact2_phone
                                  "
                                  :data-vv-name="`${$t('emergency_contact')} 2`"
                                  :error-messages="
                                    errors.collect('emergency_contact2_phone')
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              v-if="
                                registrationEditFormValues.course &&
                                  registrationEditFormValues.course.custom_field
                              "
                            >
                              <v-col>
                                <h3 class="heading mt-2 mb-2">
                                  {{ $t("custom_field") }}
                                </h3>
                                <v-checkbox
                                  v-if="registrationEditFormValues.course.custom_field_de.startsWith('#')"
                                  v-model="registrationEditFormValues.custom_field"
                                  disabled
                                  :label="
                                  this.$i18n.locale == 'de'
                                    ? registrationEditFormValues.course
                                        .custom_field_de
                                    : registrationEditFormValues.course
                                        .custom_field_it
                                "
                                ></v-checkbox>
                                <v-text-field
                                  v-else
                                  color="secondary"
                                  :label="
                                    this.$i18n.locale == 'de'
                                      ? registrationEditFormValues.course
                                          .custom_field_de
                                      : registrationEditFormValues.course
                                          .custom_field_it
                                  "
                                  name="custom_field"
                                  v-model="
                                    registrationEditFormValues.custom_field
                                  "
                                  :data-vv-name="`${$t('custom_field')} 2`"
                                  :error-messages="
                                    errors.collect('custom_field')
                                  "
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              v-if="
                                registrationEditFormValues.course && registrationEditFormValues.course.custom_field_2
                              "
                            >
                              <v-col>
                                <h3 class="heading mt-2 mb-2">
                                  {{ $t("custom_field_2") }}
                                </h3>
                                <v-checkbox
                                  v-if="registrationEditFormValues.course.custom_field_2_de.startsWith('#')"
                                  v-model="registrationEditFormValues.custom_field_2"
                                  disabled
                                  :label="
                                  this.$i18n.locale == 'de'
                                  ? registrationEditFormValues.course
                                      .custom_field_2_de
                                  : registrationEditFormValues.course
                                      .custom_field_2_it
                                "
                                ></v-checkbox>
                                <v-text-field
                                v -else
                                  color="secondary"
                                  :label="
                                    this.$i18n.locale == 'de'
                                      ? registrationEditFormValues.course
                                          .custom_field_2_de
                                      : registrationEditFormValues.course
                                          .custom_field_2_it
                                  "
                                  name="custom_field_2"
                                  v-model="
                                    registrationEditFormValues.custom_field_2
                                  "
                                  :data-vv-name="`${$t('custom_field_2')} 2`"
                                  :error-messages="
                                    errors.collect('custom_field_2')
                                  "
                                />
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            class="mr-4"
                            @click="onCloseRegistrationEdit()"
                          >
                            {{ $t("Cancel") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="onSaveRegistrationEdit()"
                            :color="currentColor()"
                            class="mr-4"
                          >
                            {{ $t("save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-dialog v-model="childDialog" width="800">
                      <v-card>
                        <v-card-title
                          :color="currentColor()"
                          class="text-h5 grey lighten-2 pb-3"
                        >
                          {{ $t("Child") }}
                          {{
                            childrenFromValues.id
                              ? $t("Edit")
                              : $t("createResource")
                          }}
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="childrenFromValues.first_name"
                                :label="$t('first_name')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="first_name"
                                :error-messages="errors.collect('first_name')"
                              ></v-text-field>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="childrenFromValues.last_name"
                                :label="$t('last_name')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="last_name"
                                :error-messages="errors.collect('last_name')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="childrenFromValues.tax"
                                :disabled="!!childrenFromValues.id"
                                :label="$t('tax')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="tax"
                                :error-messages="errors.collect('tax')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="childrenFromValues.gender"
                                disabled
                                :items="genders"
                                item-text="name"
                                item-value="id"
                                :label="$t('gender')"
                                v-validate="'required'"
                                required
                                data-vv-name="gender"
                                :error-messages="errors.collect('gender')"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <base-date-picker
                                v-model="childrenFromValues.birth"
                                disabled
                                :label="$t('birth')"
                                :errors="errors.collect('birth')"
                              ></base-date-picker>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="childrenFromValues.lang"
                                :items="languages"
                                item-text="name"
                                item-value="id"
                                :label="$t('language')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="lang"
                                :error-messages="errors.collect('lang')"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="childrenFromValues.phone"
                                :label="$t('phone')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="phone"
                                :error-messages="errors.collect('phone')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-switch
                                v-model="childrenFromValues.whatsapp_infos"
                                :label="$t('whatsapp_infos')"
                              ></v-switch>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="childrenFromValues.school"
                                :items="schools"
                                item-text="name"
                                item-value="id"
                                :label="$t('schools')"
                                autocomplete="new-password"
                                v-validate="'required'"
                                required
                                data-vv-name="school"
                                :error-messages="errors.collect('school')"
                              >
                              </v-select>
                              <p>
                                <small>{{ $t("school_year_info") }}</small>
                              </p>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-switch
                                v-model="childrenFromValues.leave_alone"
                                :label="$t('leave_alone')"
                              ></v-switch>
                            </v-col>
                            <v-col>
                              <v-switch
                                v-model="childrenFromValues.swimming_help"
                                :label="$t('swimming_help')"
                              ></v-switch>
                            </v-col>
                            <v-col>
                              <v-switch
                                v-model="childrenFromValues.with_diagnostics"
                                :label="$t('with_diagnostics')"
                              ></v-switch>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                v-model="childrenFromValues.medicaments"
                                :label="$t('medicaments')"
                                autocomplete="new-password"
                                v-validate=""
                                data-vv-name="medicaments"
                                :error-messages="errors.collect('medicaments')"
                              ></v-textarea>
                            </v-col>
                            <v-col>
                              <v-textarea
                                v-model="childrenFromValues.incompatibilities"
                                :label="$t('incompatibilities')"
                                autocomplete="new-password"
                                v-validate=""
                                data-vv-name="incompatibilities"
                                :error-messages="
                                  errors.collect('incompatibilities')
                                "
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                v-model="childrenFromValues.allergies"
                                :label="$t('allergies')"
                                autocomplete="new-password"
                                v-validate=""
                                data-vv-name="allergies"
                                :error-messages="errors.collect('allergies')"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn class="mr-4" @click="closeChildrenDialog()">
                            {{ $t("Cancel") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="onSaveChildren()"
                            :color="currentColor()"
                            class="mr-4"
                          >
                            {{ $t("save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-dialog v-model="parentDialog" width="800">
                      <v-card>
                        <v-card-title
                          :color="currentColor()"
                          class="text-h5 grey lighten-2 pb-3"
                        >
                          {{ $t("my_family.parent_data") }}
                          {{
                            $t("Edit")
                          }}
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="parentFromValues.billing_first_name"
                                :label="$t('billing_first_name')"
                                autocomplete="new-password"
                                v-validate=""
                                required
                                data-vv-name="billing_first_name"
                                :error-messages="errors.collect('billing_first_name')"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="parentFromValues.billing_last_name"
                                :label="$t('billing_last_name')"
                                autocomplete="new-password"
                                v-validate=""
                                required
                                data-vv-name="billing_last_name"
                                :error-messages="errors.collect('billing_last_name')"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                        </v-card-text>
                        <v-card-actions>
                          <v-btn class="mr-4" @click="closeParentDialog()">
                            {{ $t("Cancel") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="onSaveParent()"
                            :color="currentColor()"
                            class="mr-4"
                          >
                            {{ $t("save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>


                  </template>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="addEditChildren()"
                    small
                    :color="currentColor()"
                    class="mr-4"
                    :loading="loading"
                  >
                    <v-icon left>mdi-plus</v-icon>
                    {{ $t("Kind hinzufügen") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
              <template v-if="confirmations && confirmations.length">
                <v-divider></v-divider>

                <v-card color="grey lighten-2">
                  <v-card-text>
                    <h3 class="mb-5 mt-5">
                      <v-avatar color="indigo" size="30" class="mr-1 mb-1">
                        <span class="white--text text-">{{
                          confirmations ? confirmations.length : 0
                        }}</span>
                      </v-avatar>
                      {{ $t("payment_confirmation") }}
                    </h3>
                    <v-simple-table class="my-5 ml-3" light>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("Name") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Kurs") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Wochen") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="confirmations && confirmations.length">
                          <tr
                            v-for="(confirmation, index) in confirmations"
                            :key="index"
                          >
                            <td>{{ confirmation.child_name }}</td>
                            <td>{{ confirmation.course_name }}</td>
                            <td>{{ confirmation.week_count }}</td>
                            <td>
                              <v-btn
                                small
                                rounded
                                target="_blank"
                                :href="
                                  '/confirmation/' +
                                    confirmation.courseId +
                                    '/' +
                                    confirmation.peopleId +
                                    '/?token=' +
                                    token
                                "
                                ><v-icon>mdi-download</v-icon>DE</v-btn
                              >&nbsp;
                              <v-btn
                                small
                                rounded
                                target="_blank"
                                :href="
                                  '/confirmation/' +
                                    confirmation.courseId +
                                    '/' +
                                    confirmation.peopleId +
                                    '/it/?token=' +
                                    token
                                "
                                ><v-icon>mdi-download</v-icon>IT</v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <td colspan="4">
                            {{ $t("Keine Besätitgungen vorhanden") }}
                          </td>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </template>

              <template v-if="registrations && registrations.length">
                <v-divider></v-divider>
                <v-card color="grey lighten-2">
                  <v-card-text>
                    <h3 class="mb-5 mt-5">
                      <v-avatar color="indigo" size="30" class="mr-1 mb-1">
                        <span class="white--text text-">{{
                          registrations ? registrations.length : 0
                        }}</span>
                      </v-avatar>
                      {{ $t("current_registrations") }}
                    </h3>

                    <v-simple-table class="my-5 ml-3" light>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("Name") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Kurs") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Typ") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="registrations && registrations.length">
                          <tr
                            v-for="(item, index) in registrations"
                            :key="index"
                          >
                            <td>
                              {{ item.people.first_name }}
                              {{ item.people.last_name }}
                            </td>
                            <td>
                              <u>{{ item.course.name }}</u
                              ><br />
                              {{ item.courseWeek.name }}<br />
                              {{ item.courseWeek.from | formatDate }} -
                              {{ item.courseWeek.to | formatDate }}
                            </td>
                            <td>
                              <template v-if="item.day_type == 'half_day'">
                                <span v-if="$i18n.locale == 'de'">{{
                                  item.courseWeek.course.label_half_day_de
                                }}</span>
                                <span v-else>{{
                                  item.courseWeek.course.label_half_day_it
                                }}</span>
                              </template>
                              <template v-if="item.day_type == 'full_day'">
                                <span v-if="$i18n.locale == 'de'">{{
                                  item.courseWeek.course.label_full_day_de
                                }}</span>
                                <span v-else>{{
                                  item.courseWeek.course.label_full_day_it
                                }}</span>
                              </template>
                              <div
                                v-if="
                                  item.emergency_contact1_phone ||
                                    item.emergency_contact2_phone
                                "
                              >
                                <v-btn
                                  x-small
                                  :href="`tel:${item.emergency_contact1_phone}`"
                                  v-if="item.emergency_contact1_phone"
                                >
                                  <v-icon>mdi-phone-alert</v-icon>
                                </v-btn>
                                <v-btn
                                  x-small
                                  class="ml-1"
                                  :href="`tel:${item.emergency_contact2_phone}`"
                                  v-if="item.emergency_contact2_phone"
                                >
                                  <v-icon>mdi-phone-alert</v-icon>
                                </v-btn>
                              </div>
                            </td>
                            <td>
                              <v-btn
                                small
                                text
                                color="indigo"
                                :disabled="item.courseWeek.state != 'open'"
                                @click="editRegistration(item)"
                              >
                                <v-icon>mdi-pencil</v-icon>
                                {{ $t("edit_verb") }} </v-btn
                              ><br />
                              <v-btn
                                small
                                text
                                :disabled="item.courseWeek.state != 'open'"
                                color="red"
                                @click="deleteRegistration(item)"
                              >
                                <v-icon>mdi-delete</v-icon>
                                {{ $t("delete_verb") }}
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <td colspan="4">
                            {{ $t("Keine Anmeldungen vorhanden") }}
                          </td>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      @click="$router.push({ name: 'frontend.index' })"
                      :color="currentColor()"
                      class="mr-4"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      {{ $t("Neue Anmeldung") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>

                <v-sheet height="500" v-if="1 == 2">
                  <v-calendar
                    mt-4
                    ml-2
                    mb-5
                    :events="events"
                    :color="currentColor()"
                    type="month"
                    :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                  ></v-calendar>
                </v-sheet>
              </template>
              <template v-if="waitingQueue && waitingQueue.length">
                <v-divider></v-divider>
                <v-card color="grey lighten-2">
                  <v-card-text>
                    <h3 class="mb-5 mt-5">
                      <v-avatar color="indigo" size="30" class="mr-1 mb-1">
                        <span class="white--text text-">{{
                          waitingQueue ? waitingQueue.length : 0
                        }}</span>
                      </v-avatar>
                      {{ $t("Warteliste") }}
                    </h3>

                    <v-simple-table class="my-5 ml-3" light>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("Name") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Kurs") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Typ") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="waitingQueue && waitingQueue.length">
                          <tr
                            v-for="(item, index) in waitingQueue"
                            :key="index"
                          >
                            <td>
                              {{ item.people.first_name }}
                              {{ item.people.last_name }}
                            </td>
                            <td>
                              <u>{{ item.course.name }}</u
                              ><br />
                              {{ item.courseWeek.name }}<br />
                              {{ item.courseWeek.from | formatDate }} -
                              {{ item.courseWeek.to | formatDate }}
                            </td>
                            <td>
                              <template v-if="item.day_type == 'half_day'">
                                <span v-if="$i18n.locale == 'de'">{{
                                  item.courseWeek.course.label_half_day_de
                                }}</span>
                                <span v-else>{{
                                  item.courseWeek.course.label_half_day_it
                                }}</span>
                              </template>
                              <template v-if="item.day_type == 'full_day'">
                                <span v-if="$i18n.locale == 'de'">{{
                                  item.courseWeek.course.label_full_day_de
                                }}</span>
                                <span v-else>{{
                                  item.courseWeek.course.label_full_day_it
                                }}</span>
                              </template>
                            </td>
                            <td>
                              <v-btn
                                small
                                text
                                color="indigo"
                                @click="editRegistration(item)"
                                :disabled="item.courseWeek.state != 'open'"
                              >
                                <v-icon>mdi-pencil</v-icon>
                                {{ $t("edit_verb") }} </v-btn
                              ><br />
                              <v-btn
                                small
                                text
                                color="red"
                                @click="deleteRegistration(item)"
                                :disabled="item.courseWeek.state != 'open'"
                              >
                                <v-icon>mdi-delete</v-icon>
                                {{ $t("delete_verb") }}
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <td colspan="4">
                            {{ $t("Keine Kinder in der Warteliste vorhanden") }}
                          </td>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </template>
              <v-divider></v-divider>
              <v-card color="grey lighten-2">
                <v-card-text>
                  <h3 class="mb-5 mt-5">
                    {{ $t("payment_confirmation") }}
                  </h3>
                  <v-row>
                    <v-col>
                      <v-btn :color="currentColor()" @click="$router.push({ name: 'frontend.confirmations' })">{{
                        $t("my_family.confirmations")
                      }}</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>


            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import {
  fetchMyFamily,
  deleteRegistration,
  saveRegistration,
  saveChildren,
  saveParent
} from "./shared/services";
import codiceFiscale from "codice-fiscale-js";
export default {
  name: "app-frontend-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      /*events: [
        {
          name: "JD Summer Aldein Kombiniert [Kind 1 RA]",
          start: "2022-02-7",
          end: "2022-02-11",
          color: "#fb8c00",
          timed: false
        },
        {
          name: "JD Summer Vintl Kombiniert [Kind 1 RA]",
          start: "2022-02-21",
          end: "2022-02-24",
          color: "#1867c0",
          timed: false
        },
        {
          name: "JD Summer Vintl Kombiniert [Kind 2 RA]",
          start: "2022-02-21",
          end: "2022-02-24",
          color: "#1867c0",
          timed: false
        }
      ],*/

      registrationEditDialog: false,
      registrationEditFormValues: {},
      token: "",
      item: null,
      permissions: [],
      loading: true,
      children: null,
      registrations: null,
      confirmations: null,
      waitingQueue: null,
      childDialog: false,
      parentDialog: false,
      childrenFromValues: {},
      parentFromValues: {},
      genders: [
        {
          id: "m",
          name: this.$t("men")
        },
        {
          id: "f",
          name: this.$t("woman")
        },
        {
          id: "s",
          name: this.$t("divers")
        }
      ],
      schools: [
        {
          id: "kg_1",
          name: "1. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_2",
          name: "2. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_3",
          name: "3. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_4",
          name: "4. " + this.$t("kinder_garden_year")
        },
        {
          id: "gs_1",
          name: "1. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_2",
          name: "2. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_3",
          name: "3. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_4",
          name: "4. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_5",
          name: "5. " + this.$t("elementary_school_year")
        },
        {
          id: "ms_1",
          name: "1. " + this.$t("middle_school_year")
        },
        {
          id: "ms_2",
          name: "2. " + this.$t("middle_school_year")
        },
        {
          id: "ms_3",
          name: "3. " + this.$t("middle_school_year")
        },
        {
          id: "other",
          name: this.$t("other")
        }
      ],
      languages: [
        {
          id: "de",
          name: this.$t("de")
        },
        {
          id: "it",
          name: this.$t("it")
        }
      ]
    };
  },
  mounted() {
    this.token = localStorage.getItem("laravel-vue-spa");
    this.getData();
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  watch: {
    "childrenFromValues.tax": function(data) {
      if (data.length == 0) {
        this.childrenFromValues.birth = null;
        this.childrenFromValues.gender = null;
        return;
      }
      try {
        if (data.length == 16) {
          var cf = new codiceFiscale(data.toUpperCase());
          this.childrenFromValues.tax = data.toUpperCase();
          this.childrenFromValues.birth = cf.birthday
            .toISOString()
            .slice(0, 10);
          if (cf.gender == "M") {
            this.childrenFromValues.gender = "m";
          } else if (cf.gender == "F") {
            this.childrenFromValues.gender = "f";
          } else {
            this.childrenFromValues.gender = "s";
          }
        } else {
          throw new Error(
            "tax id != 16 length - length for (" + data + ") is =" + data.length
          );
        }
      } catch (e) {
        this.childrenFromValues.birth = null;
        this.childrenFromValues.gender = null;
      }
    }
  },
  methods: {
    async deleteRegistration(item) {
      if (
        await this.$root.$confirm(
          this.$t("Löschen"),
          this.$t(
            item.is_waiting
              ? this.$t("my_family.really_delete_queue")
              : this.$t("my_family.really_delete_registration")
          )
        )
      ) {
        let resp = await deleteRegistration(item.id);
        if (resp.data.success) {
          Swal.fire({
            icon: "success",
            text: resp.data.message
          });
          //          this.$notification(resp.data.message, { type: "success" });
          this.getData();
        } else {
          //this.$notification(resp.data.message, { type: "error" });
          Swal.fire({
            icon: "error",
            text: resp.data.message
          });
        }
      }
    },

    editRegistration(item) {
      this.$validator.reset();
      this.registrationEditFormValues = item;
      this.registrationEditDialog = true;
    },
    onCloseRegistrationEdit() {
      this.registrationEditDialog = false;
      this.registrationEditFormValues = {};
    },
    async onSaveRegistrationEdit() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveRegistration(
        this.registrationEditFormValues.id,
        {
          dayType: this.registrationEditFormValues.day_type,
          emergency_contact1_phone: this.registrationEditFormValues
            .emergency_contact1_phone,
          emergency_contact2_phone: this.registrationEditFormValues
            .emergency_contact2_phone,
          custom_field: this.registrationEditFormValues.custom_field,
          custom_field_2: this.registrationEditFormValues.custom_field_2
        },
        this.$validator
      );
      if (resp.success) {
        this.registrationEditDialog = false;
        this.registrationEditFormValues = {};
        this.$root.$notification(resp.message, { type: "success" });
        this.getData();
      } else {
        this.$root.$notification(resp.message, { type: "error" });
      }
    },

    closeChildrenDialog() {
      this.childDialog = false;
      this.childrenFromValues = {};
    },
    addEditChildren(item = null) {
      this.$validator.reset();
      if (item !== null) {
        this.childrenFromValues = item;
      }
      this.childDialog = true;
    },
    async onSaveChildren() {
      if (this.childrenFromValues.birth == null) {
        Swal.fire({
          icon: "error",
          title: this.$t("Fehler"),
          text: this.$t("error_invalid_tax")
        });
        return;
      }

      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveChildren(
        this.childrenFromValues.id,
        this.childrenFromValues,
        this.$validator
      );
      if (resp.success) {
        this.childDialog = false;
        this.childrenFromValues = {};
        this.$root.$notification(resp.message, { type: "success" });
        this.getData();

        if (this.$route.params.backUrl) {
          this.$router.push({ path: this.$route.params.backUrl });
        }
      }
    },
    getData() {
      if (!this.$auth.user().people) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.$auth.fetch();
      fetchMyFamily().then(res => {
        this.children = res.childrens;
        this.registrations = res.registrations;
        this.confirmations = res.confirmations;
        this.waitingQueue = res.waitingQueue;
        this.item = res.parent;
        this.loading = false;

        if (this.$route.params.childEditId) {
          let editChild = res.childrens.find(
            i => i.id == this.$route.params.childEditId
          );
          this.addEditChildren(editChild);
        }
      });
    },
    currentColor() {
      return this.$store.state.modules.options.app_color
        ? this.$store.state.modules.options.app_color
        : "primary";
    },

    closeParentDialog() {
      this.parentDialog = false;
      this.parentFromValues = {};
      this.getData();
    },
    addEditParent(item = null) {
      this.$validator.reset();
      if (item !== null) {
        this.parentFromValues = item;
      }
      this.parentDialog = true;
    },

    async onSaveParent() {

      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveParent(
        this.parentFromValues.id,
        this.parentFromValues,
        this.$validator
      );
      if (resp.success) {
        this.parentDialog = false;
        this.parentFromValues = {};
        this.$root.$notification(resp.message, { type: "success" });
        this.getData();

        if (this.$route.params.backUrl) {
          this.$router.push({ path: this.$route.params.backUrl });
        }
      }
    },


  }
};
</script>
